import React from 'react';
import { SkeletonText } from '../../../../components/Tables/Skeleton';
import { Label } from 'flowbite-react';

const MondaySettingsSkeleton = () => {
  return (
    <div className="px-8 py-12 -mt-0.5 flex-1">
      <div className="mb-4">
        <Label htmlFor="api-token-skeleton">
          <span className="text-gray-900 dark:text-white">API Token *</span>
        </Label>
        <div className="mt-1.5">
          <SkeletonText width="w-full" height="h-10" className="rounded-lg" />
        </div>
      </div>

      <div className="mb-4">
        <Label htmlFor="states-skeleton">
          <span className="text-gray-900 dark:text-white">States</span>
        </Label>
        <div className="mt-1.5">
          <SkeletonText width="w-full" height="h-40" className="rounded-lg" />
        </div>
      </div>

      <div className="flex items-center mt-4">
        <SkeletonText width="w-9" height="h-5" className="rounded-full" />
        <SkeletonText width="w-48" height="h-4" className="ml-3" />
      </div>
    </div>
  );
};

export default MondaySettingsSkeleton; 